import {NgModule} from '@angular/core';

import {TuiTiptapEditorDirective} from './tiptap-editor.directive';

@NgModule({
    declarations: [TuiTiptapEditorDirective],
    exports: [TuiTiptapEditorDirective],
})
export class TuiTiptapEditorModule {}
